export default (slug, locale) => {
  const lang = locale.currentLanguage.pathPrefix || "";
  const stdSlug = slug.endsWith("/") ? slug : `${slug}/`;
  return `${lang}${stdSlug}`;
};
